(() => {
  const modulo = (value, length) => ((value % length) + length) % length;
  const reduceMotionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');

  function initProductTurn(root) {
    const stage = root.querySelector('[data-turn-stage]');
    const frames = [...root.querySelectorAll('[data-turn-frame]')];
    const counter = root.querySelector('[data-turn-counter]');
    const status = root.querySelector('[data-turn-status]');
    const hint = root.querySelector('[data-turn-hint]');
    if (!stage || frames.length < 2) return;

    let activeIndex = Math.max(0, frames.findIndex((frame) => !frame.hidden));
    let pointerId = null;
    let pointerStartX = 0;
    let pointerStep = 0;
    let pointerDragged = false;
    let ignoreNextClick = false;

    const updateHint = () => {
      if (!hint) return;
      hint.textContent = reduceMotionQuery?.matches
        ? 'Use the arrows or controls to browse images'
        : 'Drag or tap to turn';
    };

    const setFrame = (nextIndex, announce = true) => {
      activeIndex = modulo(nextIndex, frames.length);
      frames.forEach((frame, index) => {
        const isActive = index === activeIndex;
        frame.hidden = !isActive;
        frame.classList.toggle('is-active', isActive);
        frame.setAttribute('aria-hidden', String(!isActive));
      });
      if (counter) counter.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(frames.length).padStart(2, '0')}`;
      if (announce && status) status.textContent = `Image ${activeIndex + 1} of ${frames.length}`;
    };

    const changeFrame = (delta) => setFrame(activeIndex + delta);

    root.querySelectorAll('[data-turn-control]').forEach((control) => {
      control.addEventListener('click', () => changeFrame(control.dataset.turnControl === 'previous' ? -1 : 1));
    });

    stage.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); changeFrame(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); changeFrame(1); }
      if (event.key === 'Home') { event.preventDefault(); setFrame(0); }
      if (event.key === 'End') { event.preventDefault(); setFrame(frames.length - 1); }
    });

    stage.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 || event.target.closest('[data-turn-control]')) return;
      pointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStep = 0;
      pointerDragged = false;
      stage.setPointerCapture?.(event.pointerId);
    });

    stage.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;
      const nextStep = Math.trunc((event.clientX - pointerStartX) / 36);
      if (nextStep === pointerStep) return;
      event.preventDefault();
      changeFrame(-(nextStep - pointerStep));
      pointerStep = nextStep;
      pointerDragged = true;
    });

    const endPointer = (event) => {
      if (pointerId !== event.pointerId) return;
      if (stage.hasPointerCapture?.(event.pointerId)) stage.releasePointerCapture?.(event.pointerId);
      pointerId = null;
      if (pointerDragged) {
        ignoreNextClick = true;
        window.setTimeout(() => { ignoreNextClick = false; }, 0);
      }
    };

    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
    stage.addEventListener('click', (event) => {
      if (event.target.closest('[data-turn-control]')) return;
      if (ignoreNextClick) { ignoreNextClick = false; return; }
      const bounds = stage.getBoundingClientRect();
      changeFrame(event.clientX < bounds.left + bounds.width / 2 ? -1 : 1);
    });

    reduceMotionQuery?.addEventListener?.('change', updateHint);
    updateHint();
    setFrame(activeIndex, false);
  }

  document.querySelectorAll('[data-product-turn]').forEach(initProductTurn);
})();
